import styled from 'styled-components';

export const StyledDriverHeader = styled.span`
  text-transform: lowercase;
  text-transform: capitalize;
  .availability {
    margin-left: 5px;
    text-transform: lowercase;
    font-weight: normal;
    font-style: italic;
    color: #7990a6;
  }
`;
